import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames';
import shallowCompare from 'shallow-compare';

import CheckIcon from '@ott/icon-check';

import styles from './Option.scss';

class Option extends React.Component {
  static propTypes = {
    onMouseOver: PropTypes.func,
    onMouseOut: PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    onMouseDown: PropTypes.func,
    withArrow: PropTypes.bool,
    withPadding: PropTypes.bool,
    isTouchDevice: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    withArrow: true,
    withPadding: true,
  };

  constructor(props, ctx) {
    super(props, ctx);

    this.handleOptionMouseOver = this.handleOptionMouseOver.bind(this);
    this.handleOptionMouseOut = this.handleOptionMouseOut.bind(this);
    this.handleOptionMouseEnter = this.handleOptionMouseEnter.bind(this);
    this.handleOptionMouseLeave = this.handleOptionMouseLeave.bind(this);

    this.handleClick = this.handleClick.bind(this);

    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
  }

  componentWillReceiveProps({ isActive }) {
    this._isActive = isActive;
  }

  handleOptionMouseOver(e) {
    const { onMouseOver, value } = this.props;

    if (onMouseOver) {
      return onMouseOver(value, this.props, e);
    }
  }

  handleOptionMouseOut(e) {
    const { onMouseOut, value } = this.props;

    if (onMouseOut) {
      return onMouseOut(value, this.props, e);
    }
  }

  handleOptionMouseEnter(e) {
    const { onMouseEnter, value } = this.props;

    if (onMouseEnter) {
      return onMouseEnter(value, this.props, e);
    }
  }

  handleOptionMouseLeave(e) {
    const { onMouseLeave, value } = this.props;

    if (onMouseLeave) {
      return onMouseLeave(value, this.props, e);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.pureChildren) {
      const { children, ...rest } = nextProps;
      return shallowCompare(this, rest, nextState);
    }
    return shallowCompare(this, nextProps, nextState);
  }

  handleTouchStart(e) {
    const { onTouchStart } = this.props;

    const { clientX, clientY } = e.changedTouches[0];
    this._activeTarget = {
      target: e.currentTarget,
      clientX,
      clientY,
    };

    onTouchStart && onTouchStart(e);
  }

  handleClick(e) {
    const { value, isGroup, isDisabled, onClick } = this.props;

    if (e) {
      e.preventDefault();
      e.stopPropagation();

      /**
       * stopImmediatePropagation нужен для того, чтобы предотвратить закрытие parent-компонента
       * Пример: форма поиска на жд. В Bar компоненте вещается обработчик document.onTouchEnd
       * Если не делать stopImmediatePropagation, событие всплывает, элемент из списка не выбирается,
       * следовательно невозможно осуществить новый поиск.
       */
      if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) {
        e.nativeEvent.stopImmediatePropagation();
      }
    }

    if (!isGroup || isDisabled) {
      return onClick(value);
    }
  }

  isValidTouch(e) {
    const { clientX, clientY } = e.changedTouches[0];
    const target = document.elementFromPoint(clientX, clientY);

    if (
      !this._activeTarget ||
      !this._activeTarget.target ||
      !this._activeTarget.target.contains(target)
    ) {
      this._activeTarget = null;
      return false;
    }

    // если при таче сдвинули палец менее чем на 10px, то считаем что может быть клик
    if (
      Math.abs(this._activeTarget.clientX - clientX) > 10 ||
      Math.abs(this._activeTarget.clientY - clientY) > 10
    ) {
      this._activeTarget = null;
      return false;
    }

    return true;
  }

  handleTouchMove(e) {
    this.isValidTouch(e);
  }

  handleTouchEnd(e) {
    const { onTouchEnd } = this.props;

    if (this.isValidTouch(e)) {
      this.handleClick(e);

      onTouchEnd && onTouchEnd(arguments);
    }

    this._activeTarget = null;
  }

  render() {
    const {
      children,
      isActive,
      isSelected,
      isGroup,
      isDisabled,
      withArrow,
      withPadding,
      className,
      value, // remove from restProps
      pureChildren, // remove from restProps
      isHovered, // remove from restProps
      onClick, // remove from restProps
      isTouchDevice,
      ...restProps
    } = this.props;

    return (
      <div
        {...restProps}
        onTouchStart={this.handleTouchStart}
        onTouchMove={this.handleTouchMove}
        onTouchEnd={this.handleTouchEnd}
        onMouseUp={!isTouchDevice ? this.handleClick : undefined}
        onMouseOver={!isTouchDevice ? this.handleOptionMouseOver : undefined}
        onMouseOut={!isTouchDevice ? this.handleOptionMouseOut : undefined}
        onMouseEnter={!isTouchDevice ? this.handleOptionMouseEnter : undefined}
        onMouseLeave={!isTouchDevice ? this.handleOptionMouseLeave : undefined}
        className={cls(
          styles.Option,
          className,
          isActive && styles.activeOption,
          isSelected && styles.selectedOption,
          isGroup && styles.groupOption,
          !withPadding && styles.withoutPaddingOption,
          isDisabled && styles.disabledOption
        )}
      >
        <span className={styles.inner}>{children}</span>
        {withArrow && <CheckIcon className={styles.arrow} />}
      </div>
    );
  }
}

export default Option;
